import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Spinner from 'components/spinner/Spinner';
import { getStatementsPDF } from 'services/AccountService';
import { formatCycleDate } from 'utils/Date';

import { ReactComponent as PdfIcon } from './pdf-icon.svg';

const StatementItem = ({ statement }) => {
    const [isFetching, setIsFetching] = useState(false);
    const docId = statement.link;
    const docName = statement.key.split('/')[1];
    const handlePdfDownload = async () => {
        setIsFetching(true);
        try {
            const documentStream = await getStatementsPDF(docId);
            const url = window.URL.createObjectURL(new Blob([documentStream]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.setAttribute('download', `${docName}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {
        } finally {
            setIsFetching(false);
        }
    };
    const { month, year } = formatCycleDate(statement.cycleDate);
    return (
        <li className="statement-item" id="statement-item" onClick={handlePdfDownload}>
            <h4>
                <FormattedMessage id={month} />
                {` ${year}`}
            </h4>
            {isFetching ? <Spinner /> : <PdfIcon />}
        </li>
    );
};

export default StatementItem;
